import { render } from "./CommunityHealth.vue?vue&type=template&id=0dc90cb8&scoped=true"
import script from "./CommunityHealth.vue?vue&type=script&lang=js"
export * from "./CommunityHealth.vue?vue&type=script&lang=js"

import "./CommunityHealth.vue?vue&type=style&index=0&id=0dc90cb8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc90cb8"]])

export default __exports__